export default {"src":"/_next/static/media/invisible-logo-purple.d7d7ad68.svg","height":26,"width":154};